module.exports = __webpack_public_path__ + "img/BM.20002c96.png";